import React from 'react'
import { Button } from 'react-bootstrap'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

export const TestList = ({ }) => {
  const dispatch = useDispatch()
  const { action } = useSelector(state => state.ui)
  const tests = useSelector(state=>state.medical_tests)
  
  const newTest = () => dispatch({ type: "NEW_TEST" })
  const showEditTestModal = (resource) => {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "test",
        resource
      }
    })
  }

  return(
    <>
      <Table sm="sm" responsive>
        <thead>
          <tr>
            <th>Kind</th>
            <th>Performed On</th>
            <th>Result</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            tests.map(test=>(
              <tr>
                <td>{ test.kind }</td>
                <td>{ moment(test.performed_on).format("MM/DD/YYYY") }</td>
                <td className="text-capitalize">{ test.result }</td>
                <td>{ test.notes }</td>
                <td>
                  {
                    action === "edit" &&
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        showEditTestModal(test);
                      }}>
                      Edit
                    </a>
                  }
                </td>
              </tr>
            ))
          }
          {
            action == 'edit' &&
            <tr>
              <td colSpan={5} className="text-center">
                <Button 
                  onClick={newTest}
                  variant="link">
                  Add Test
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    </>
  )
}